import * as Yup from "yup";
import { isValidAbnOrAcn } from "utils/helpers";

const PHONE_REGEX =
	/^(?=.*)((?:\+?61) ?(?:\((?=.*\)))?([2-47-8])\)?|(?:\((?=.*\)))?([0-1][2-47-8])\)?) ?-?(?=.*)((\d{1} ?-?\d{3}$)|(00 ?-?\d{4} ?-?\d{4}$)|( ?-?\d{4} ?-?\d{4}$)|(\d{2} ?-?\d{3} ?-?\d{3}$))/;

export const getValidationSchema = (profileTypeId: number) => {
	const isClient = profileTypeId === 1;
	const isHC = profileTypeId === 2;
	const isSub = profileTypeId === 3;
	const isConsultant = profileTypeId === 4;

	return Yup.object({
		name: Yup.string()
			.required()
			.max(80, "Business name should not exceed 80 characters"),
		status: isClient ? Yup.string() : Yup.string().required(),
		company_number: Yup.string(),
		sector_ids: Yup.array().min(1, "You must select at least one sector."),
		speciality_ids:
			isHC || isSub ? Yup.string().required() : Yup.string(),
		description: Yup.string()
			.required()
			.test(
				"not-empty-html",
				"This is a required field",
				(value) => {
					if (!value) return false;
					const stripped = value.replace(/<[^>]*>/g, "").trim();
					return stripped.length > 0;
				}
			),
		contact_name: Yup.string().required(),
		phone: Yup.string()
			.required("This is a required field")
			.matches(PHONE_REGEX, "Invalid Phone No."),
		disciplines: Yup.array().when("profile_type", {
			is: (pt: number) => pt === 4,
			then: Yup.array().of(
				Yup.object().shape({
					expertise: Yup.string().required(),
					disciplines: Yup.array().required().min(1),
				})
			),
		}),
		abn: Yup.string()
			.required("This is a required field")
			.test(
				"test abn/acn",
				"Your ABN/ACN number is invalid",
				(value) => !!value && isValidAbnOrAcn(value)
			)
			.nullable(true),
		email: Yup.string().email().required(),
		website: Yup.string(),
		size_type_id: isClient ? Yup.string() : Yup.string().required(),
		trade_ids: isSub ? Yup.string().required() : Yup.string(),
		global_presence: isClient ? Yup.mixed() : Yup.array().required(),
		years_trading: isClient ? Yup.mixed() : Yup.number().required(),
		logo: Yup.mixed().required(),
		banner_image: Yup.mixed().required(),
	});
};
